var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMicOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0049 14.8659C14.1083 14.8659 15.5563 13.2762 15.5563 11.0192V4.84673C15.5563 2.57991 14.1083 1 12.0049 1C9.89168 1 8.44375 2.57991 8.44375 4.84673V11.0192C8.44375 13.2762 9.89168 14.8659 12.0049 14.8659ZM7.63173 22H16.3683C16.7792 22 17.1118 21.6762 17.1118 21.264C17.1118 20.8519 16.7792 20.5182 16.3683 20.5182H12.7386V18.2318C16.4759 17.9178 19 15.229 19 11.3724V9.38037C19 8.96822 18.6771 8.64439 18.2662 8.64439C17.8553 8.64439 17.5227 8.96822 17.5227 9.38037V11.3136C17.5227 14.6598 15.3508 16.8776 12.0049 16.8776C8.6492 16.8776 6.47729 14.6598 6.47729 11.3136V9.38037C6.47729 8.96822 6.15444 8.64439 5.73375 8.64439C5.32285 8.64439 5 8.96822 5 9.38037V11.3724C5 15.229 7.53389 17.9178 11.2614 18.2318V20.5182H7.63173C7.22082 20.5182 6.88819 20.8519 6.88819 21.264C6.88819 21.6762 7.22082 22 7.63173 22Z",
    fill: "#878793"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMicOn);
export default __webpack_public_path__ + "static/media/icon-mic-on.40261aea70727d31dcb5e9a5ca964800.svg";
export { ForwardRef as ReactComponent };